var r = {
  guard: "Navigation was cancelled by a navigation guard",
  superseded: "Navigation was superseded by a later navigation"
}, e = class extends Error {
  reason;
  constructor(a) {
    super(r[a]), this.name = "NavigationCancelledError", this.reason = a;
  }
};
export {
  e as NavigationCancelledError
};

//# sourceMappingURL=ReactRouterAdapter.types.js.map